export default __webpack_public_path__ + "static/media/Greet.c2bdd23d.mov";